import clsx from "clsx";
import { Link } from "components/layout/link";
import { SidebarItem, SidebarLabel, SidebarMode } from "components/layout/sidebar";
import React from "react";

interface NgSidebarItemProps {
    label: string;
    icon: React.ComponentType<{ className?: string }>;
    mode: SidebarMode;
    href?: string;
    current?: boolean;
    expandable?: boolean;
    expanded?: boolean;
    onExpandToggle?: () => void;
    onClick?: React.MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
    className?: string;
}

export const NgSidebarItem: React.FC<NgSidebarItemProps> = ({
    label,
    icon: Icon,
    mode,
    href,
    current,
    expandable,
    expanded,
    onExpandToggle,
    onClick,
    className,
}) => {
    if (mode === "icons") {
        return (
            <Link
                href={href || "#"}
                target={href?.startsWith("http") ? "_blank" : undefined}
                rel={href?.startsWith("http") ? "noopener noreferrer" : undefined}
                onClick={onClick as React.MouseEventHandler<HTMLAnchorElement>}
                className={clsx(
                    "p-2 rounded-lg",
                    current
                        ? "bg-brand-700 text-white dark:bg-brand-900/40 dark:text-brand-100"
                        : "text-brand-800 hover:bg-zinc-950/5 dark:text-brand-400 dark:hover:bg-brand-950/30",
                    className,
                )}
                title={label}>
                <Icon className="size-5" />
            </Link>
        );
    }

    return (
        <SidebarItem
            href={href}
            current={current}
            className={className}
            expandable={expandable}
            expanded={expanded}
            onExpandToggle={onExpandToggle}
            onClick={onClick}
            mode={mode}>
            <Icon />
            <SidebarLabel>{label}</SidebarLabel>
        </SidebarItem>
    );
};
